<template>
    <div id="order_list">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: "OrderList",
    methods: {
        childByValue(childValue) {
            alert(childValue);
        },
    },
};
</script>



<style scoped>
#order_list {
    display: flex;
    flex-direction: column;
    width: 100%;
}
</style>
